/**
 * Capture workflow transitions & guards (ported from Noteble — ADR-022).
 *
 * Guards are pure functions: they take the current context and return a
 * boolean. The component calls them before applying a transition.
 */

import type { WorkflowContext } from './types';

export const initialContext: WorkflowContext = {
  step: 'capture',
  inputMethod: 'voice',
  note: '',
  capturedStreams: [],
  selectedTemplates: [],
  isSubmitting: false,
  error: null,
  activeDraftId: null,
  isRestoring: false,
};

/**
 * Can the user advance past the capture step?
 * True when there is at least some captured content. Photos and saved notes
 * live in AddContext (external), so the caller passes `hasExternalContent`.
 */
export function canAdvanceFromCapture(
  ctx: WorkflowContext,
  hasExternalContent = false,
): boolean {
  const hasText = !!ctx.note.trim();
  const hasStreams = ctx.capturedStreams.length > 0;
  return hasText || hasStreams || hasExternalContent;
}

/** Can the user submit? */
export function canSubmit(ctx: WorkflowContext): boolean {
  return ctx.selectedTemplates.length > 0 && !ctx.isSubmitting;
}
